import React from 'react'
import { Switch, Route, useLocation, Redirect } from 'react-router-dom'
import  SpotifyContextContainer from './hoc/context/SpotifyContextContainer'

import PrivateRoute  from './hoc/PrivateRoute'

import Login from './components/login/Login'
import HomeContainer from './components/home/HomeContainer'
import PlaylistContainer from './components/playlist/PlaylistContainer'
import BrowserContainer from './components/browse/BrowseContainer'


export default function Routes() {
    const location = useLocation()

    return (
        <SpotifyContextContainer>
                <Switch>
                    <Route path="/login" component={Login}/>
                    <PrivateRoute path="/" exact component={HomeContainer}/>
                    <PrivateRoute path="/playlist/:id" exact component={PlaylistContainer}/>
                    <PrivateRoute path="/discover" exact component={BrowserContainer}/>
                </Switch>
        </SpotifyContextContainer>
    )
}
